import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Link, Loader } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { checkEnvironment, getMessageKey } from '../../utils/utils';

import './AccessRequestHistory.css';

const FIELDS_TO_EXCLUDE = ['securitySystem'];

function AccessRequestHistorySubTitle({
  isError,
  isLoading,
  data,
  messageKeys,
}) {
  const intl = useIntl();
  const { ECM_URL } = checkEnvironment();
  const { messages } = useSelector((state) => state?.user);

  const hasContentForSubtitles = Boolean(Object?.keys(data)?.length > 0);

  return (
    <Box tag='div' className='AccessRequestHistoryModalSubTitle'>
      {!isError && isLoading && (
        <Loader kind='dots' format='inline' color='brand' size='small' />
      )}
      {!isError && !isLoading && hasContentForSubtitles && (
        <div className='AccessRequestHistoryModalSubTitle-text'>
          {Object.keys(data)?.map((key) => {
            if (!FIELDS_TO_EXCLUDE.includes(key)) {
              return (
                <React.Fragment key={key}>
                  <span className='AccessRequestHistoryModalSubTitle-textBoxKey'>
                    {`${
                      messages[messageKeys?.[key]] ||
                      localize(intl, getMessageKey(messageKeys?.[key]))
                    }:`}
                    &nbsp;
                  </span>
                  <span className='AccessRequestHistoryModalSubTitle-textBoxValue'>
                    {data[key]}
                  </span>
                  <span className='AccessRequestHistoryModalSubTitle-textBoxTerminate' />
                </React.Fragment>
              );
            }

            return null;
          })}
        </div>
      )}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  -- should be from design system */}
      <Link
        url={`${ECM_URL}/jbpmworkflowmanagement/showmyhistoryrequests`}
        text={
          messages['ARS.redirectLink.label.ATTESTATIONS'] ||
          localize(intl, getMessageKey('ARS.redirectLink.label'))
        }
        color='brand'
        size='large'
        suffixIconKind='JumpLink'
      />
    </Box>
  );
}

AccessRequestHistorySubTitle.propTypes = {
  isError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({}),
  messageKeys: PropTypes.shape({}),
};

AccessRequestHistorySubTitle.defaultProps = { data: null, messageKeys: null };

export default AccessRequestHistorySubTitle;
